import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue') 
const Pagamento = () => import('./Pagamento.vue') 
const PagamentoAssociarDespesas = () => import('./PagamentoAssociarDespesas.vue')

export default {
    path: 'pagamentos',
    name: 'DespesasGerais_Fornecedores_Pagamentos',
    component: Pagamentos,
    beforeEnter(to, from, next) {
        if (temAcesso('DESP-GERAIS-FORN-PAG-00')) {
            next();
        }
    },
    children: [
        {
            path: ':pagamentoId',
            name: 'DespesasGerais_Fornecedores_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter(to, from, next) {
                if (temAcesso('DESP-GERAIS-FORN-PAG-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'associardespesas',
                    name: 'DespesasGerais_Fornecedores_Pagamentos_AssociarDespesas',
                    component: PagamentoAssociarDespesas,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('DESP-GERAIS-FORN-PAG-03')) {
                            next()
                        }
                    }
                }
            ]
        },
    ]
}